import { CollapsibleTableHeadCell } from '../components/tables/BakeasyCollapsibleTable';
import { HeadCell } from '../components/tables/BakeasyTable';

export const storeTableHeaders: HeadCell[] = [
  { id: 'storeNumber', label: 'STORE_ID', sort: true },
  { id: 'storeName', label: 'STORE_NAME', sort: true, width: '190px' },
  { id: 'contact', label: 'STORE_CONTACT', sort: true, width: '190px' },
  { id: 'createdDate', label: 'DATE_CREATED', sort: true },
  { id: 'lastAccess', label: 'LAST_ACCESS' },
  { id: 'totalOrders', label: 'TOTAL_ORDERS', sort: true, align: 'right' },
  { id: 'totalOrderValue', label: 'TOTAL_ORDER_VALUE', sort: true, align: 'right' },
  { id: 'assignedProducts', label: 'ASSIGNED_PRODUCTS', sort: true, align: 'right' },
  { id: 'status', label: 'STATUS', align: 'center' },
  { id: 'actions', label: 'EDIT', align: 'center' }
];

export const storeProductsTableHeaders: HeadCell[] = [
  { id: 'productChecked', label: '' },
  { id: 'productName', label: 'NAME', sort: true },
  { id: 'price', label: 'PRICE' },
  { id: 'categoryName', label: 'CATEGORY', sort: true },
  { id: 'subCategoryName', label: 'SUB_CATEGORY', sort: true },
  { id: 'status', label: 'STATUS', align: 'center', sort: true },
  { id: 'productStatus', label: 'ASSIGNMENT', align: 'center', sort: true }
];

export const categoriesTableHeaders: HeadCell[] = [
  { id: 'categoryName', label: 'CATEGORY_NAME', sort: true },
  { id: 'description', label: 'DESCRIPTION' },
  { id: 'status', label: 'STATUS', sort: true, align: 'center' },
  { id: 'actions', label: 'ACTIONS', align: 'center' }
];

export const subCategoriesTableHeaders: HeadCell[] = [
  { id: 'subCategoryName', label: 'SUBCATEGORY_NAME', sort: true },
  { id: 'description', label: 'DESCRIPTION' },
  { id: 'status', label: 'STATUS', sort: true, align: 'center' },
  { id: 'actions', label: 'ACTIONS', align: 'center' }
];

export const productTableHeaders: HeadCell[] = [
  { id: 'productChecked', label: '' },
  { id: 'productName', label: 'PRODUCT_NAME', sort: true, width: '190px' },
  { id: 'productID', label: 'PRODUCT_ID' },
  { id: 'categoryName', label: 'CATEGORY', sort: true },
  { id: 'subCategoryName', label: 'SUB_CATEGORY', sort: true },
  { id: 'productType', label: 'PRODUCT_TYPE' },
  { id: 'add', label: 'ADD_TO_ALL_STORES', align: 'center' },
  { id: 'status', label: 'STATUS', align: 'center' },
  { id: 'isReceipeBuilder', label: 'RECIPE_BUILDER', sort: true, align: 'center' },
  { id: 'actions', label: 'ACTIONS', align: 'center' }
];

export const ingredientTableHeadersEditable: HeadCell[] = [
  { id: 'ingredientName', label: 'INGREDdfIENT_NAME' },
  { id: 'measureType', label: 'MEASURE_TYPE' },
  { id: 'units', label: 'QUANTITY_PER_UNIT', disabled: false },
  { id: 'price', label: 'PRICE' },
  { id: 'actions', label: 'ACTIONS' }
];

export const ingredientTableHeaders: HeadCell[] = [
  { id: 'ingredientName', label: 'INGREDIENT_NAME' },
  { id: 'measureType', label: 'MEASURE_TYPE', disabled: false },
  { id: 'units', label: 'QUANTITY_PER_UNIT', disabled: false },
  { id: 'price', label: 'PRICE', disabled: false },
  { id: 'actions', label: 'ACTIONS' }
];

export const ingredientTableHeadersForView: HeadCell[] = [
  { id: 'ingredientName', label: 'INGREDIENT_NAME' },
  { id: 'measureType', label: 'MEASURE_TYPE', disabled: true },
  { id: 'units', label: 'QUANTITY_PER_UNIT', disabled: true, align: 'right' },
  { id: 'price', label: 'PRICE', disabled: true, align: 'right' }
];

export const ordersTableHeaders: HeadCell[] = [
  // { id: 'orderId', label: 'ORDER_ID', sort: true, width: '190px' },
  { id: 'orderId', label: 'ORDER_ID', sort: true },
  { id: 'storeName', label: 'STORE_NAME', sort: true },
  // { id: 'orderDate', label: 'ORDER_DATE', sort: true, width: '160px' },
  { id: 'orderDate', label: 'ORDER_DATE', sort: true },
  // { id: 'requestedDeliveryDate', label: 'DUE_DATE', sort: true, width: '160px' },
  { id: 'requestedDeliveryDate', label: 'DUE_DATE', sort: true },
  { id: 'variance', label: 'VARIANCE', align: 'center' },
  { id: 'totalPrice', label: 'TOTAL_PRICE', align: 'right' },
  { id: 'status', label: 'STATUS', sort: true, align: 'center' },
  { id: 'actions', label: 'ACTIONS', align: 'center' }
];

export const editOrderTableHeaders: HeadCell[] = [
  { id: 'productName', label: 'PRODUCT_NAME' },
  { id: 'quantity', label: 'QUANTITY' },
  { id: 'confirmedQuantity', label: 'CONFIRM_QUANTITY' },
  { id: 'processOrderChecked', label: 'PROCESS' },
  { id: 'backOrderChecked', label: 'BACKORDER' },
  { id: 'cancelOrderChecked', label: 'CANCEL' }
];

export const orderDetailsTableHeaders: HeadCell[] = [
  { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
  { id: 'userProductId', label: 'PRODUCT_ID', width: '160px' },
  { id: 'quantity', label: 'QUANTITY', numeric: true, width: '120px' },
  { id: 'unitPrice', label: 'UNIT_PRICE', numeric: true, width: '120px' },
  {
    id: 'confirmedQuantity',
    label: 'CONFIRMED_QUANTITY',
    numeric: true,
    width: '120px',
    disabled: true
  },
  { id: 'totalPrice', label: 'TOTAL_PRICE', numeric: true, width: '120px' }
];

// export const proessesOrdertableheaders: HeadCell[] = [
//   { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
//   { id: 'quantity', label: 'UNIT', numeric: true, width: '100px' },
//   { id: 'price', label: 'PRICE', numeric: true, width: '100px' },
//   { id: 'totalPrice', label: 'TOTAL_PRICE', numeric: true, width: '100px' }
// ];

export const messageTableHeaders: HeadCell[] = [
  { id: 'messageDateTime', label: 'DATE_MM_DD_YYYY', width: '120px' },
  { id: 'from', label: 'FROM' },
  { id: 'to', label: 'TO', width: '180px' },
  { id: 'priority', label: 'PRIORITY' },
  { id: 'subject', label: 'SUBJECT', width: '200px' },
  { id: 'recsent', label: 'STATUS' },
  { id: 'content', label: 'CONTENT', width: '200px' },
  { id: 'actions', label: 'ACTIONS' }
];

export const shippedOrderTableHeaders: HeadCell[] = [
  { id: 'productName', label: 'PRODUCT_NAME' },
  { id: 'quantity', label: 'QUANTITY' },
  { id: 'shippingQuantity', label: 'SHIPPED_QUANTITY' }
];

export const activeOrderTableHeaders: HeadCell[] = [
  { id: 'orderId', label: 'ORDER_ID', sort: true },
  { id: 'storeName', label: 'STORE_NAME', sort: true },
  { id: 'orderDate', label: 'ORDER_DATE', sort: true },
  { id: 'requestedDeliveryDate', label: 'DUE_DATE', sort: true },
  { id: 'variance', label: 'VARIANCE', align: 'center' },
  { id: 'totalPrice', label: 'TOTAL_PRICE', align: 'right' },
  { id: 'status', label: 'STATUS', sort: true, align: 'center' },
  { id: 'actions', label: 'ACTIONS', align: 'center' }
];

export const shippingTableHeaders: HeadCell[] = [
  { id: 'shippingId', label: 'SHIPPING_ID', sort: true },
  { id: 'order_Id', label: 'ORDER_ID' },
  { id: 'storeName', label: 'STORE_NAME' },
  { id: 'storePo', label: 'STORE_PO' },
  { id: 'dueDate', label: 'DATE_TO_BE_DELIVERED', sort: true },
  { id: 'shippedDate', label: 'SHIPPED_DATE' },
  { id: 'totalPrice', label: 'TOTAL_PRICE', align: 'right' },
  { id: 'status', label: 'STATUS', align: 'center' }
];

export const reportTableHeaders: CollapsibleTableHeadCell[] = [
  { id: 'icon', label: '', width: '30px' },
  { id: 'invoiceId', label: 'INVOICE_ID' },
  { id: 'orderId', label: 'ORDER_ID', width: '200px' },
  { id: 'name', label: 'STORE_NAME', width: '200px' },
  { id: 'storepo', label: 'STORE_PO' },
  { id: 'status', label: 'STATUS' },
  { id: 'orderDate', label: 'ORDER_DATE', width: '150px' },
  { id: 'shippedDate', label: 'SHIPPED_DATE', width: '150px' },
  { id: 'invoicedDate', label: 'INVOICED_DATE', width: '150px' },
  { id: 'invoicedValue', label: 'INVOICED_VALUE', width: '150px', align: 'right' }
];

export const tableHeaders: CollapsibleTableHeadCell[] = [
  { id: 'invoiceId', label: 'INVOICE_ID' },
  { id: 'subOrderId', label: 'SUBORDER_ID' },
  { id: 'status', label: 'STATUS' },
  { id: 'orderDate', label: 'ORDER_DATE' },
  { id: 'shipDate', label: 'SHIPPED_DATE', shippingMemo: true },
  { id: 'invoicedDate', label: 'INVOICED_DATE' },
  { id: 'invoicedValue', label: 'INVOICED_VALUE', align: 'right' }
];
